<template>
    <div>
        <p class="title">{{this.title}}</p>
        <select class="input-select" v-model="selected" @change="setDefaultAndUpdateParent($event)">
            <option
                v-for="option in options"
                :key="option.id"
            >
            {{option}}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: "SelectReportComponent",
    props: {
        title: {
            type: String,
            required: true
        },
        reports: {},
        options: {}
    },
    data(){
        return {
            selected: ""
        }
    },
    methods: {
        setDefaultAndUpdateParent(){
            this.reports.forEach(item=>{
                if(item.title == this.selected){
                    // send item title and endpoint to parent
                    // best would have been to send `id` instead of these other ones
                    this.$emit('updateSelectedReport', this.selected, item.endpoint)
                }
            })
        }
    },
    mounted(){
        // this.setDefaultAndUpdateParent();
    }
}
</script>

<style lang="scss" scoped>
    .input-select{
        width: 100%;
        background-color: #FFF;
        box-sizing: border-box;
        color: #606266;
        padding: 0 15px;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
    }
    .titleClass{
        position: absolute;
        color: #999;
        padding: 7px 15px;
    }
    .title{
        flex-wrap: wrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyReportComponents/SelectReportComponent.vue